module.exports = __webpack_public_path__ + "static/media/505-error.8523a3de.svg";